import React, { useContext } from "react";
import { CButton } from "@app/components/Common";
import { View } from "@/styles/reactnative";
import { COLORS } from "@app/constants";
import { useTranslation } from "react-i18next";
import { ThemeContext } from "@/theme/ThemeProvider";

const RankingTopTabs = ({ tab, setTab, tabs }: any) => {
  const { gray, grey, drawerBgColor } = useContext(ThemeContext).theme.COLORS;
  const { t } = useTranslation();
  return (
    <View
      style={{
        flexDirection: "row",
        justifyContent: "flex-start",
        background: "transparent",
      }}
    >
      {tabs.map((item: any, index: any) => (
        <CButton
          key={index.toString()}
          title={item && t(item)}
          onClick={() => {
            setTab(item);
          }}
          style={{
            color: tab === item ? COLORS.primary : COLORS.lightGray5,
            fontWeight: "500",
            paddingBlock: 15,
            paddingInline: 20,
            backgroundColor: drawerBgColor,
            boxShadow:
              tab === item
                ? index === 1
                  ? `-3px 0px 15px 0px ${gray}`
                  : `5px 0px 3px  ${grey}`
                : "0 0 0  #fff",
            borderRadius: 0,
            borderTopLeftRadius: 10,
            borderTopRightRadius: tab === item ? 35 : 30,
            zIndex: tab === item ? 1 : 0,
            marginLeft: index === 1 ? -1 : undefined,
          }}
          backgroundHover={COLORS.lightGray3}
        />
      ))}
    </View>
  );
};

export default RankingTopTabs;
